import React from "react";
import Card2 from "../Images/Headers/team.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import { IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

import Card1 from "../Images/Profiles/Alex.jpg";
import Card3 from "../Images/Profiles/Fred.jpg";
import Card4 from "../Images/Profiles/Godfrey.jpg";
import Card5 from "../Images/Profiles/Joseph.jpg";
import Card6 from "../Images/Profiles/Juliet.jpg";
import Card7 from "../Images/Profiles/Denis.jpg";
import Card8 from "../Images/Profiles/Kenneth.jpeg";

/* ─── Centralised directors data ─────────────────────────── */
const DIRECTORS = [
  {
    id: "kenneth-arinaitwe",
    photo: Card8,
    name: "Dr. Kenneth Arinaitwe",
    role: "Chairman, Executive Council",
    bio: "Kenneth is a holder of a Doctor of Philosophy degree conferred by Makerere University, specializing in Environmental Analytical Chemistry. His ...",
    linkedin: "https://ug.linkedin.com/in/kennetharinaitwe",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/Circodu/",
    whatsapp: "https://wa.me/256772858394",
    email: "kenneth.arinaitwe@circodu.org.ug",
  },
  {
    id: "denis-muhangi",
    photo: Card7,
    name: "Dr. Denis Muhangi",
    role: "Vice Chairman, Executive Council",
    bio: "Denis earned a Doctor of Philosophy Degree from Makerere University, where his research delved into the ...",
    linkedin: "https://www.linkedin.com/in/denis-muhangi-69564077/",
    twitter: "https://twitter.com/mdenis_1234",
    facebook: "https://www.facebook.com/muhangi.denis.3",
    whatsapp: "https://wa.me/256785284996",
    email: "denis.muhangi@circodu.org.ug",
  },
  {
    id: "joseph-ndemere-arineitwe",
    photo: Card5,
    name: "Mr. Joseph Ndemere Arineitwe",
    role: "Director General",
    bio: "Joseph possesses a Master's degree in Mechanical Engineering with a specialization in Sustainable Energy Engineering, ...",
    linkedin: "https://www.linkedin.com/in/joseph-ndemere-arineitwe-56474625/",
    twitter: "https://twitter.com/josephndemere",
    facebook: "https://www.facebook.com/josephndemere.arineitwe/",
    whatsapp: "https://wa.me/256782433627",
    email: "joseph.ndemere@circodu.org.ug",
  },
  {
    id: "juliet-kyayesimira",
    photo: Card6,
    name: "Dr. Juliet Kyayesimira",
    role: "Secretary General",
    bio: "Juliet holds the position of Secretary General at the Center for Integrated Research and Community Development Uganda (CIRCODU), ...",
    linkedin: "https://www.linkedin.com/in/dr-juliet-kyayesimira-37488587/",
    twitter: "https://twitter.com/Jkyayesimira",
    facebook: "https://www.facebook.com/juliet.kyayesimira/",
    whatsapp: "https://wa.me/256702557243",
    email: "kyayesimira@circodu.org.ug",
  },
  {
    id: "godfrey-muhwezi",
    photo: Card4,
    name: "Mr. Godfrey Muhwezi",
    role: "Director",
    bio: "Godfrey is concurrently pursuing his doctoral studies in Chemistry and serving as a Chemistry Doctoral Candidate at Kyambogo University. His educational ...",
    linkedin: "https://www.linkedin.com/in/muhwezi-godfrey-a20abb29/",
    twitter: "https://twitter.com/GodfreyMuhwez",
    facebook: "https://www.facebook.com/muhwezi.godfrey/",
    whatsapp: "https://wa.me/256772384731",
    email: "godfrey.muhwezi@circodu.org.ug",
  },
  {
    id: "alexander-atuyamba",
    photo: Card1,
    name: "Mr. Alexander Atuyamba",
    role: "Director",
    bio: "Alexander is a qualified professional with a Master of Science degree in Agroecology and a Bachelor of Science degree in Organic Agriculture, both earned from ...",
    linkedin: "https://www.linkedin.com/in/atuyamba-alex-43b18931/",
    twitter: "https://twitter.com/AtuyambaAlex",
    facebook: "https://www.facebook.com/atuyamba.alexander/",
    whatsapp: "https://wa.me/256783430017",
    email: "alex.atuyamba@circodu.org.ug",
  },
  {
    id: "fred-isabirye",
    photo: Card3,
    name: "Mr. Fred Isabirye",
    role: "Field Manager",
    bio: "Fred holds a Master's Degree in Intellectual Property (MIP) from Africa University and a Bachelor of Science Degree in Mechanical Engineering (BSc MEC) from ...",
    linkedin: "https://www.linkedin.com/in/fred-isabirye-b0b59791/",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/Circodu/",
    whatsapp: "https://wa.me/256752876969",
    email: "fred.isabirye@circodu.org.ug",
  },
];

/* ─── Single director card ───────────────────────────────── */
function DirectorCard({ member }) {
  const {
    id,
    photo,
    name,
    role,
    linkedin,
    twitter,
    facebook,
    whatsapp,
    email,
  } = member;
  const profileUrl = `/${id}`;

  return (
    <div className="staff-card">
      {/* Photo */}
      <div className="staff-card__photo-wrap">
        <a
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="staff-card__photo-link"
          aria-label={`View profile of ${name}`}
        >
          <img
            src={photo}
            alt={name}
            className="staff-card__photo"
            width="160"
            height="160"
            loading="lazy"
          />
        </a>
      </div>

      {/* Info */}
      <div className="staff-card__body">
        <a
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="staff-card__name"
          aria-label={`View profile of ${name}`}
        >
          {name}
        </a>
        <p className="staff-card__role">{role}</p>
        <div className="staff-card__divider" />
        <div className="staff-card__actions">
          <a
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="staff-card__read-more"
            aria-label={`Read more about ${name}`}
          >
            Read More
          </a>
        </div>
      </div>

      {/* Social icons
          tabIndex={-1} removes IconButton from tab order since the parent <a>
          already handles focus — fixes aria-hidden/focusable descendants warning. */}
      <div className="staff-card__socials">
        <a
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} on LinkedIn`}
        >
          <IconButton size="small" tabIndex={-1}>
            <LinkedInIcon sx={{ fontSize: "20px", color: "darkblue" }} />
          </IconButton>
        </a>
        <a
          href={twitter}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} on X / Twitter`}
        >
          <IconButton size="small" tabIndex={-1}>
            <XIcon sx={{ fontSize: "20px", color: "#111" }} />
          </IconButton>
        </a>
        <a
          href={facebook}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} on Facebook`}
        >
          <IconButton size="small" tabIndex={-1}>
            <FacebookOutlinedIcon sx={{ fontSize: "20px", color: "#1877f2" }} />
          </IconButton>
        </a>
        <a
          href={whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`WhatsApp ${name}`}
        >
          <IconButton size="small" tabIndex={-1}>
            <WhatsAppIcon sx={{ fontSize: "20px", color: "#25d366" }} />
          </IconButton>
        </a>
        <a
          href={`mailto:${email}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Email ${name}`}
        >
          <IconButton size="small" tabIndex={-1}>
            <EmailIcon sx={{ fontSize: "20px", color: "#e53935" }} />
          </IconButton>
        </a>
      </div>
    </div>
  );
}

/* ─── Page component ─────────────────────────────────────── */
function BoardofDirectors() {
  return (
    <div>
      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img
            src={Card2}
            alt="CIRCODU Top Management Team"
            width="1200"
            height="220"
            loading="eager"
            fetchpriority="high"
          />
        </div>
        <div className="ne-hero__overlay">
          <h1 className="ne-hero__title">Top Management</h1>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>The Team</Breadcrumb.Item>
            <Breadcrumb.Item active>Top Management</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* Director General's Message */}
      <section className="staff-section border-bottom">
        <div className="staff-section__header">
          <div className="row border-top"></div>
        </div>
        <div className="container">
          <div className="container-flex">
            <div className="row">
              <div className="col-md-12">
                <h2 className="main-heading">Director General's Message</h2>
                <div className="underline-card4"></div>
                <p className="textBOD">
                  Welcome, and thank you for taking the time to visit us.
                </p>
                <p className="textBOD">
                  On behalf of the entire CIRCODU family, it is my sincere
                  pleasure to greet you here. Whether you are a long-standing
                  partner, a prospective collaborator, or someone discovering
                  our work for the very first time, you are warmly welcome, and
                  we are glad you are here.
                </p>
                <p className="textBOD">
                  CIRCODU was built on the conviction that research, done well
                  and applied purposefully, can transform lives. Since our
                  inception in 2007, that conviction has only deepened. We have
                  watched communities gain access to clean energy, cleaner
                  water, and the knowledge to build better futures for
                  themselves. We have seen data shape policy, and policy shape
                  lives. And with every project we undertake, every partnership
                  we forge, and every community we serve, we are reminded of why
                  this work matters.
                </p>
                <p className="textBOD">
                  Our commitment at CIRCODU has always been to excellence, not
                  excellence for its own sake, but excellence in service of real
                  people and real impact. We hold ourselves to the highest
                  standards of integrity, transparency, and professionalism, and
                  we continuously seek to improve through innovation,
                  collaboration, and honest engagement with the communities and
                  partners we work with.
                </p>
                <p className="textBOD">
                  As you explore this platform, I invite you to learn about our
                  team, our approach, our projects, and the values that guide
                  everything we do. I hope you will find not just information,
                  but inspiration and perhaps the beginning of a meaningful
                  partnership.
                </p>
                <p className="textBOD">
                  If you have questions, ideas, or simply wish to connect,
                  please do not hesitate to reach out. At CIRCODU, every
                  conversation is an opportunity, and every partnership is a
                  step forward.
                </p>
                <p className="textBOD">
                  Thank you once again for your interest and your trust.
                </p>
                <div className="mb-2 signoff">
                  <p className="textBOD">
                    <b>With warm regards,</b>
                  </p>
                  <a
                    href="/joseph-ndemere-arineitwe"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="signoff"
                  >
                    <b>Mr. Joseph Ndemere Arineitwe</b>
                  </a>
                  <p className="textsignoff">
                    <b>Director General</b>
                  </p>
                </div>
                <hr />
                <p className="textBOD mt-2">
                  <i>
                    Together, we research. Together, we build. Together, we
                    transform.
                  </i>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Directors Grid */}
        <div className="row border-top text-center mb-4"></div>
        <div className="staff-grid">
          {DIRECTORS.map((member) => (
            <DirectorCard key={member.id} member={member} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default BoardofDirectors;
